import DefaultSetting from '../services/defaultSetting.service';
// import moment from 'moment';

export const defaultSetting = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    getDefaultSetting({ commit }){
      return DefaultSetting.getDefaultSetting().then(
        resp => {
          commit('getDefaultSetting', resp);
          return Promise.resolve(resp);
        },
        error => {
          commit('getDefaultSetting');
          return Promise.reject(error);
        }
      )
    }, 

    updateDefaultSetting({ commit }, setting) {
      return DefaultSetting.updateDefaultSetting(setting).then(
        resp => {
          commit("updateDefaultSetting", resp);
          return Promise.resolve(resp);
        },
        error => {
          commit("updateDefaultSetting");
          return Promise.reject(error);
        }
      )
    }   
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    }
  }
};